import { Device, from } from '@helpers/media';
import CardCarouselStyles from '@stories/Components/CardCarousel/CardCarousel.styles';
import styled from 'styled-components';
const Wrapper = styled.div `
  ${CardCarouselStyles.Container} {
    --visibleItems: 1;

    @media ${from(Device.Tablet)} {
      --visibleItems: 2;
    }

    @media ${from(Device.DesktopSmall)} {
      --visibleItems: 3;
    }
  }
`;
const MediaCarouselStyles = {
    Wrapper,
};
export default MediaCarouselStyles;
